var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('a',{staticClass:"link mr-2",attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v(_vm._s(_vm.id || '-'))]),_vm._v(" "),_c('div',{staticClass:"copy-button-container"},[_c('v-icon',{staticClass:"copy-button",attrs:{"small":"small","title":"Copy ID"},on:{"click":_vm.copyButton}},[_vm._v("mdi-content-copy")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44672ef2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/ExternalId.vue
// module id = null
// module chunks = 